<!-- 选择题 -->
<template>
  <div
    :class="{
      ['question_' + questionInfo.id]: true,
      'big-question-detail-wrap': !questionInfo.pid,
    }"
  >
    <div
      class="choice-question-wrap"
      :class="{
        is_wrong: judgeWrong,
      }"
    >
      <!-- 完型填空不展示题干 -->
      <template
        v-if="
          questionInfo.big_question_type !==
          QUESTION_TYPE_NAME.COMPLETE_BLANK_FILL
        "
      >
        <question-type
          :info="{
            question_type: questionInfo.question_type,
            score: questionInfo.score,
          }"
        />
        <!-- 题干 -->
        <div class="question-content-wrap">
          <span> {{ questionIndexObj[questionInfo.id] + 1 }}.</span>
          <div
            v-if="questionInfo.content"
            class="question-content"
            v-html="questionInfo.content"
          />
        </div>
      </template>
      <!-- 标记 -->
      <button
        @click="handleMarkQuestion(questionInfo)"
        v-preventReClick
        class="mark-btn"
      >
        <img
          v-if="questionInfo.is_markers === 1"
          src="../../../assets/images/homework/mark-icon.png"
          alt=""
        />
        <img
          v-else
          src="../../../assets/images/homework/un-mark-icon.png"
          alt=""
        />
      </button>
      <!-- 选项列表 -->
      <div
        v-if="
          questionInfo?.option?.length &&
          [
            QUESTION_TYPE_NAME.SINGLE_CHOICE,
            QUESTION_TYPE_NAME.MULTIPLE_CHOICE,
            QUESTION_TYPE_NAME.JUDGE,
          ].includes(questionInfo.question_type)
        "
        class="choice-answers"
      >
        <custom-option
          :type="
            questionInfo.question_type === QUESTION_TYPE_NAME.MULTIPLE_CHOICE
              ? 'checkbox'
              : 'radio'
          "
          :options="handleOptions"
          v-model="questionInfo.userAnswer"
          @select-change="handleSelectChange"
          :disabled="!canSubmit"
        />
      </div>
      <!-- 解析 -->
      <el-collapse v-if="isCorrected" v-model="activeNames">
        <el-collapse-item :name="0">
          <template slot="title">文字解析</template>
          <div
            v-if="questionInfo.analysis"
            v-html="questionInfo.analysis"
          ></div>
          <div v-else>暂无解析</div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import QuestionType from "@saas/pages/src/homework/components/QuestionType.vue";
import { answerQuestion } from "@saas/server-api/src/homework/index";
import CustomOption from "@saas/pages/src/homework/components/CustomOption.vue";
import {
  QUESTION_TYPE_NAME,
  WORK_STATUS,
} from "@saas/components/src/constants/question";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      QUESTION_TYPE_NAME,
      activeNames: [],
    };
  },
  methods: {
    ...mapActions("defaultHomework", [
      "apiMarkerQuestion",
      "apiAnswerQuestion",
    ]),
    handleMarkQuestion(questionInfo) {
      let { id, subIndex, pidIndex } = questionInfo;
      let params = {
        work_id: this.workId,
        question_id: id,
        is_markers: this.questionInfo?.is_markers === 1 ? 2 : 1,
        subIndex,
        pidIndex,
      };
      this.apiMarkerQuestion(params);
    },
    handleSelectChange(val) {
      let { pid, id, userAnswer, question_type } = this.questionInfo;
      let params = {
        work_id: this.workId,
        question_pid: pid,
        question_id: id,
        answer: String(userAnswer),
        question_type,
      };
      this.apiAnswerQuestion(params);
    },
  },
  computed: {
    ...mapGetters("defaultHomework", ["questionIndexObj", "canSubmit"]),
    ...mapState("defaultHomework", [
      "workId",
      "questionList",
      "workInfo",
      "isCorrected",
      "showErrorAnalysis",
    ]),
    handleOptions() {
      return this.questionInfo.option.map((option) => {
        return {
          ...option,
          value: String(option.id),
          label: option.answer,
        };
      });
    },
    judgeWrong() {
      // 已批改且非复合题且未答对
      return (
        this.isCorrected &&
        !this.questionInfo?.pid &&
        !this.questionList?.[this.questionIndexObj?.[this.questionInfo?.id]]
          ?.is_right
      );
    },
  },
  components: {
    CustomOption,
    QuestionType,
  },
};
</script>

<style lang="scss" scoped>
.choice-question-wrap.is_wrong {
  position: relative;
  &::after {
    border-radius: 12px 12px 0px 0px;
    display: block;
    content: "";
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 44px;
    background: linear-gradient(
      180deg,
      rgba(255, 153, 153, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
}

.choice-question-wrap {
  background: #fff;
  padding: 20px 12px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  .mark-btn {
    position: absolute;
    z-index: 2;
    top: 16px;
    right: 16px;
    width: 26px;
    height: 26px;
    img {
      width: 100%;
      height: 100%;
    }
    &:disabled {
      opacity: 1;
    }
  }

  .question-type,
  .question-content-wrap {
    margin-left: 8px;
  }
  .question-content {
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    line-height: 28px;
    margin-left: 4px;
    line-break: anywhere;
  }
  .choice-answers {
    display: flex;
    flex-direction: column;
    .answer-item {
      display: flex;
    }
  }
  .question-content-wrap {
    display: flex;
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    line-height: 28px;
  }
  // 解析
  ::v-deep .el-collapse {
    margin-top: 13px;
    border: none;
    .el-collapse-item__header {
      height: 40px;
      // border: 1px solid #f2f3f5;
      border: none;
      background: #ffffff;
      border-radius: 8px;
      padding: 10px 10px 10px 16px;
      font-size: 14px;
      color: #1d2129;
      line-height: 20px;
      font-weight: 400;
      position: relative;
      &::before {
        display: block;
        content: "";
        position: absolute;
        width: 2px;
        height: 12px;
        background: $homework-right-color;
        border-radius: 1px;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .el-collapse-item {
      border-radius: 8px;
      // border: none;
      border: 1px solid #f2f3f5;
    }
    .el-collapse-item__content {
      font-weight: 500;
      font-size: 16px;
      color: #1d2129;
      line-height: 26px;
      padding: 0 12px 12px;
      border-radius: 8px;
      line-break: anywhere;
    }
    .el-collapse-item__arrow {
      width: 24px;
      height: 24px;
      background: #ffffff;
      border-radius: 6px;
      // border: 1px solid #e5e6eb;
      position: relative;
      &::before {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .el-collapse-item__wrap {
      border-bottom: 0;
      border-radius: 8px;
    }
    .el-collapse-item__arrow.el-icon-arrow-right.is-active {
      transform: rotate(-90deg);
    }
    .el-collapse-item__arrow.el-icon-arrow-right {
      transform: rotate(90deg);
    }
  }
}
</style>
